import styled, { css } from 'styled-components';

import { styledMedia } from '@pkg/primitives';

interface StyledVisualAssetProps {
    // Background styles are necessary for Safari,
    // as it will not render a `poster` for Audio files.
    // https://codesandbox.io/s/audio-via-video-hdqyhb
    $bgPoster?: string;
    $contain?: boolean;
    $hoverZoom?: boolean;
    // Some browsers will show a "flash of broken image icon".
    // Use `$hideAsset` during `error || loading` to suppress that.
    $hideAsset?: boolean;
}

// TODO: Consider a prop to choose "cover / contain" behaviour.
const baseStyles = css`
    ${styledMedia.mediaCover};
    display: block;
    position: absolute;
    clip-path: var(--visual-asset-clip-path);
    object-fit: var(--visual-asset-object-fit);
`;

export const StyledVisualAsset = styled.div<StyledVisualAssetProps>`
    --visual-asset-clip-path: ${({ $hideAsset }) => ($hideAsset ? 'polygon(0 0, 1px 0, 1px 1px, 0 1px)' : undefined)};
    --visual-asset-object-fit: ${({ $contain }) => ($contain ? 'contain' : 'cover')};

    position: relative;
    width: 100%;
    height: 100%;

    ${({ $hoverZoom }) =>
        $hoverZoom &&
        css`
            cursor: pointer;
        `};

    ${({ $bgPoster }) =>
        $bgPoster &&
        css`
            background-image: url(${$bgPoster});
            background-position: center;
            background-size: var(--visual-asset-object-fit);
        `};
`;

export const VideoAsset = styled.video`
    // '&&' required to combat 'v2-global-reset'.
    && {
        ${baseStyles};
    }
`;

export const ImageAsset = styled.img<{ $hoverZoom?: boolean }>`
    // '&&' required to combat 'v2-global-reset'.
    && {
        ${baseStyles};
    }
    ${({ $hoverZoom }) =>
        $hoverZoom &&
        css`
            transition: transform 0.2s ease-in-out;
            cursor: pointer;
            &:hover {
                transform: scale(1.1);
            }
        `};
`;
